import { gql } from '@apollo/client'

export const TRADING_CENTRAL_LINK = gql`
  query TradingCentralLink($page: String, $theme: String) {
    tradingCentralLink(page: $page, theme: $theme)
  }
`
